import type { AppMode } from "@/state/app.state";
import { authedClient } from "./authedClient";
import { demoClient } from "./demoClient";

export function getClient(mode: AppMode) {
  return mode === "demo" ? demoClient : authedClient;
}
